import { BankAccountSettings } from './types';

export const bankAccountSettings: BankAccountSettings = {
  componentVariants: {
    variant: {
      prop: 'variant',
      variants: {
        primary: {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'gray.light',
          borderRadius: 0,
          background:
            'radial-gradient(101.58% 289.6% at 100% 0%, #F0F4F8 0%, #FFFFFF 100%), #F3F6FA;',
        },
      },
    },
    cardSize: {
      prop: 'cardSize',
      variants: {
        small: {
          width: '250px',
          height: '140px',
        },
        regular: {
          width: '320px',
          height: '180px',
        },
      },
    },
    addressSize: {
      prop: 'addressSize',
      variants: {
        small: {
          paddingTop: 2,
          paddingRight: 4,
          paddingBottom: 2,
          paddingLeft: 4,
          backgroundColor: 'primary.extraLight',
        },
        regular: {
          paddingTop: 3,
          paddingRight: 6,
          paddingBottom: 3,
          paddingLeft: 6,
          backgroundColor: 'primary.extraLight',
        },
      },
    },
    contentSize: {
      prop: 'contentSize',
      variants: {
        'regular-false': {
          paddingTop: 5,
          paddingRight: 6,
          paddingBottom: 6,
          paddingLeft: 6,
        },
        'regular-true': {
          paddingTop: 5,
          paddingRight: 6,
          paddingBottom: 4,
          paddingLeft: 6,
        },
        'small-false': {
          paddingTop: 3,
          paddingRight: 4,
          paddingBottom: 3,
          paddingLeft: 4,
        },
        'small-true': {
          paddingTop: 3,
          paddingRight: 4,
          paddingBottom: 3,
          paddingLeft: 4,
        },
      },
    },
    status: {
      prop: 'status',
      variants: {
        active: {
          borderColor: 'success.main',
        },
        error: {
          borderColor: 'danger.main',
        },
      },
    },
  },
};
